import {Request} from 'requests/RequestConstants';
import {RequestTask} from 'requests/tasks/RequestTaskConstants';
import {SampleGroupResponse} from 'samples/sample-groups/SampleGroupConstants';
import * as net from 'util/Net';
import {SampleGroupUpdate} from 'workflows/WorkflowConstants';

import {CreateRequestArgs, UpdateRequestArgs} from './InputReduxActions';

interface CreateRequestResponse extends SampleGroupResponse {
  request: Request;
  requestTasks: Array<RequestTask>;
  sampleGroupIdsByRequestTaskId: {[taskId: string]: Array<string>};
}

export function createRequest(data: CreateRequestArgs): Promise<CreateRequestResponse> {
  return Promise.resolve(net.postJSON({url: '/1/api/requests', data}));
}

export function updateRequest(requestId: string, data: UpdateRequestArgs): Promise<{request: Request}> {
  return Promise.resolve(
    net.patchJSON({
      url: `/1/api/requests/${requestId}`,
      data,
    })
  );
}

export function bulkUpdateRequests(
  requestIds: Array<string>,
  data: UpdateRequestArgs
): Promise<{requests: Array<Request>}> {
  return Promise.resolve(
    net.postJSON({
      url: '/1/api/requests:bulk-update',
      data: {
        ...data,
        requestIds,
      },
    })
  );
}

interface UpdateRequestSampleGroupsResponse extends SampleGroupResponse {
  sampleGroupIdsByRequestTaskId: {[taskId: string]: Array<string>};
}

export function updateRequestSampleGroups({
  requestId,
  sampleGroupIdsByRequestTaskId,
  sampleGroups,
}: {
  requestId: string;
  sampleGroupIdsByRequestTaskId: {[taskId: string]: Array<string>};
  sampleGroups: Array<SampleGroupUpdate>;
}): Promise<UpdateRequestSampleGroupsResponse> {
  return Promise.resolve(
    net.patchJSON({
      url: `/1/api/requests/${requestId}/sample-groups`,
      data: {sampleGroupIdsByRequestTaskId, sampleGroups},
    })
  );
}
